import { render, staticRenderFns } from "./StatusAndRole.vue?vue&type=template&id=0f885ecc&scoped=true&"
import script from "./StatusAndRole.vue?vue&type=script&lang=js&"
export * from "./StatusAndRole.vue?vue&type=script&lang=js&"
import style0 from "./StatusAndRole.vue?vue&type=style&index=0&id=0f885ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f885ecc",
  null
  
)

export default component.exports